<template>
  <div>
    <div class="pie-box">
      <div class="text-day">{{dayCon}}</div>
      <p class="text-steps-p1">{{daySteys}}步</p>
    </div>
    <!-- 柱状图开始 -->
    <div class="chart-box">
      <ve-histogram
        :data="chartData"
        height="95vw"
        :settings="chartSettings"
        :extend="chartExtend"
        :colors="colors"
        :events="tenDepChartEvents"
      ></ve-histogram>
      <p class="toast-p">左右滑动查看更多</p>
    </div>
    <div v-if="noDate">
      <van-empty
        class="custom-image"
        :image="require('../../../assets/images/txt_noDate.png')"
        description="暂无数据"
      />
    </div>
    <!-- 柱状图结束 -->
  </div>
</template>
<script type="text/ecmascript-6">
import VeHistogram from "v-charts/lib/histogram";
import { toast } from "@/common/api/api.js";
import moment from "moment";
export default {
  props: {
    echartsDate: {
      type: Object
    },
    tabName: {
      type: String
    }
  },
  components: {
    VeHistogram
  },
  data() {
    this.colors = ["#5689F0"]; //柱状图颜色
    this.chartSettings = {
      yAxisType: ["KMB", "percent"]
    };
    var self = this;
    this.tenDepChartEvents = {
      click: function(e) {
        self.tenDepChartClicked(e);
      }
    };
    return {
      noDate: false,
      chartData: {
        columns: ["day", "步数"],
        rows: []
      },
      chartExtend: {
        legend: {
          show: false
        },
        series: {
          barWidth: 18,
          itemStyle: {
            //通常情况下：
            normal: {
              //当前选中的柱子使用亮色，其余的使用基本颜色
              color: function(param) {
                //如果是选中的index则返回高亮颜色，否则返回默认颜色
                return self.selectedDepIndex == param.dataIndex
                  ? "#399AE8"
                  : "#5689F0";
              }
            }
          }
        },
        xAxis: [
          {
            type: "category",
            axisLabel: {
              show: true,
            }
          }
        ],
        dataZoom: [
          {
            type: "slider",
            throttle: "50",
            minValueSpan: 4,
            start: 0,
            end: 15
          }
        ],
        // dataZoom: [
        //   {
        //     type: "slider",
        //     show: true,
        //     start: 0,
        //     end: 15,
        //     handleSize: 8
        //   },
        //   {
        //     type: "inside",
        //     start: 0,
        //     end: 15
        //   },
        //   {
        //     type: "slider",
        //     show: true,
        //     yAxisIndex: 0,
        //     filterMode: "empty",
        //     width: 12,
        //     height: "70%",
        //     handleSize: 8,
        //     showDataShadow: false,
        //     left: "93%"
        //   }
        // ],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        }
      },
      selectedDepIndex: 0, //鼠标点击选中的数据项
      dayCon: "", //随着点击联动的日期
      daySteys: "" //随着点击联动的步数
    };
  },
  methods: {
    init() {},
    day(index, str) {
      this.chartData.rows[index].day = moment(str).format("DD");
    },

    week(index, str) {
      let weekDate = str.split("_");
      let weekParts1 = moment(weekDate[0]).format("MM/DD");
      let weekParts2 = moment(weekDate[1]).format("MM/DD");
      this.chartData.rows[index].day = `${weekParts1} - ${weekParts2}`;
    },
    month(index, str) {
      this.chartData.rows[index].day = moment(str).format("M月");
    },
    tenDepChartClicked(e) {
      //根据鼠标点击事件设置选中的项
      this.selectedDepIndex = e.dataIndex;
      // this.reFreshDepTen();
    },
    //刷新图表：清空图表数据再重新赋值，只有图表数据变化了图表才会重新绘制
    reFreshDepTen() {
      var temp = this.chartData.rows;
      this.chartData.rows = [];
      this.chartData.rows = temp;
    }
  },
  watch: {
    // 将后台返回的数据转换成为自己想要的数据
    echartsDate(val) {
      let that = this;
      that.chartData.rows = []; //清空原来数据---swq
      if (val.timeList) {
        this.selectedDepIndex = val.timeList.length - 1; //默认高亮数据的最后一项
      }
      for (let index in val.timeList) {
        const titeObj = {
          day: val.timeList[index],
          步数: val.stepCounts[index]
        };
        that.chartData.rows.push(titeObj);
        this[that.tabName](index, val.timeList[index]);
      }
    },

    funday(item) {
      let storeDate = this.echartsDate;
      this.dayCon = moment(storeDate.timeList[item]).format("MM月DD日");
    },

    selectedDepIndex(item) {
      let storeDate = this.echartsDate;
      if (this.tabName === "day") {
        //根据点击改变高亮的index去找数据赋值
        this.dayCon = moment(storeDate.timeList[item]).format("MM月DD日");
      }
      if (this.tabName === "week") {
        let weekDate = this.echartsDate.timeList[item].split("_");
        let weekParts1 = moment(weekDate[0]).format("MM月DD日");
        let weekParts2 = moment(weekDate[1]).format("MM月DD日");
        this.dayCon = `${weekParts1} - ${weekParts2}`;
      }
      if (this.tabName === "month") {
        this.dayCon = this.echartsDate.timeList[item];
      }
      this.daySteys = storeDate.stepCounts[item]; //根据点击改变高亮的index去找数据赋值(步数)
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../../assets/stylus/common.styl';
@import '../../../assets/stylus/theme.styl';

.toast-p {
  font-size: 14px;
  color: $main-bgColor;
  text-align: center;
  padding: 10px 0 20px;
}

.chart-box {
  margin-top: -50px;
}

.pie-box {
  padding: 0 10px;
}

.text-day {
  height: 12px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000;
  line-height: 12px;
}

.text-steps-p1 {
  height: 26px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(0, 0, 0, 1);
  line-height: 26px;
}
</style>